import React from "react";

function Instagram() {
    const style = {
        margin :"0 0 10px",
    };
    return (
        <div id="bot-scene-container">
            <div id="bot-scene-content" className="scroll-light">
                <div className="app-v2-faq-list-empty-wrapper">
                    <div className="app-v2-faq-list-empty">
                        <div className="app-v2-faq-empty-left">
                            <div className="app-v2-faq-empty-title">
                                <span>Thiết lập câu hỏi và phản hồi tự động cho hội thoại Instagram</span>
                            </div>
                            <div className="app-v2-faq-empty-content">
                                <p style={style}>
                                    Bạn có thể thiết lập câu hỏi thường gặp và câu trả lời tương ứng để cung cấp thông tin hữu ích (địa chỉ cửa hàng, chính sách giao nhận, đổi trả hàng...), hoặc thu thập thông tin khách hàng trong lần tương tác đầu tiên. 
                                </p>
                                <p style={style}>
                                    Tính năng giúp khoảng thời gian khách hàng chờ đến phiên được nhân viên tư vấn phản hồi trở nên ý nghĩa hơn, nâng tầm trải nghiệm khách hàng.
                                </p>
                            </div>
                            <div className="app-v2-faq-footer">
                                <p style={style}>
                                    Xem thêm hướng dẫn chi tiết <a className="app-v2-faq-empty-content--click-here" href="" target="_blank" rel="noopener noreferrer">tại đây</a>.
                                </p>
                                <button className="btn btn-primary app-v2-btn-icon">
                                    <span>Tạo câu hỏi</span>
                                </button>
                            </div>
                        </div>
                        <div className="app-v2-faq-empty-right">
                            <div className="svg-next-icon" style={{ backgroundImage: "url('https://static.harasocial.com/svg-funnel/ic-instagram-icebreaker.svg')", backgroundRepeat: "no-repeat", backgroundPosition: "center center", backgroundSize: "520px 416px", width: "520px", height: "416px" }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Instagram;